import Rellax from 'rellax';

// Rellaxを".js-parallax-target"クラスを指定して初期化
if (document.querySelector('.p-kodawari')) {
	const rellax = new Rellax('.js-parallax-target', {
		breakpoints: [375, 768, 1024]
	});
}
